import { z } from "zod";

export const musicianProfileSchema = z.object({
  profileId: z.number().optional(),
  name: z.string().min(1, "Required"),
  description: z.string().min(1, "Required"),
  role: z.enum(["MUSICIAN", "CLIENT"]),
  profileImage: z.string().min(1, "Required"),
  originalProfileImage: z.string().min(1, "Required"),
  images: z.array(z.string()).optional(),
  audioSamples: z.array(z.string()).optional(),
  videoSamples: z.array(z.string()).optional(),
  startedDate: z.coerce.date(),
  price: z.coerce.number(),
  phoneNumber: z.coerce.string().min(1, "Required"),
  travelDistance: z.coerce.number().positive().optional(),
  location: z.object({
    country: z.string(),
    region: z.string(),
    city: z.string(),
  }),
});

export const clientProfileSchema = musicianProfileSchema.pick({
  profileId: true,
  role: true,
  name: true,
  phoneNumber: true,
  profileImage: true,
  originalProfileImage: true,
});

export const sendContactMessageSchema = z.object({
  name: z.string().min(1, "Required"),
  phone: z.string().min(1, "Required"),
  email: z.string().email(),
  message: z.string().min(1, "Required"),
});

export const leaveReviewSchema = z.object({
  musicianId: z.coerce.number(),
  title: z.string().min(1, "Required").optional(),
  body: z.string().min(1, "Required"),
  rating: z.coerce.number().min(1).max(5),
  images: z.array(z.string()).optional(),
});

export const followUpReminderBodySchema = z.object({ quoteId: z.number() });
export const upsellBodySchema = z.object({ profileId: z.number() });
